import { Badge } from "primereact/badge"
import { Button } from "primereact/button"
import { clearSingleFilter, countFilterCalendarAppliedFilters, countFilterListCheckboxAppliedFilters, countFilterListRadioAppliedFilters, countFilterTreeCheckboxAppliedFilters } from "./mapFiltersFunctions"
import { MapFilter } from "./types"
import { useMapDispatch } from "../../../../../stateManagement/hooks/useMapDispatch"
import { MapName } from "../../../../../stateManagement/reducers/maps/actions"

// Функция для получения шаблона заголовка аккордеона
export function getAccordionTabHeaderTemplate(
    mapFiltersState: any,
    filterConfig: MapFilter,
    mapName: MapName,
    dispatchMap: ReturnType<typeof useMapDispatch>
) {
    const { fieldName, format, operation, caption, canBeIgnored } = filterConfig ?? {}
    const filterState = mapFiltersState?.[fieldName]
    const { isIgnored, values, nodes } = filterState ?? {}
    let showClearFiltersButton = !isIgnored

    let numberOfActiveFilters
    if (format === 'list-checkbox' && values) {
        numberOfActiveFilters = countFilterListCheckboxAppliedFilters(filterState)
    }
    if (format === 'list-radio' && values) {
        numberOfActiveFilters = countFilterListRadioAppliedFilters(filterState)
    }
    if (format === 'tree-checkbox' && nodes) {
        numberOfActiveFilters = countFilterTreeCheckboxAppliedFilters(filterState)
    }
    // if (type === "input") {
    //     showClearFiltersButton = !ignoreFilter
    //     numberOfActiveFilters = 1
    // }
    if (format === "calendar") {
        const { minValue, maxValue, value } = filterState ?? {}
        if (operation === "between" && (!maxValue || !minValue)) showClearFiltersButton = false;
        numberOfActiveFilters = countFilterCalendarAppliedFilters(filterState)
    }
    return (
        <div className="map-overlay-filter-header-div">
            <span className="map-overlay-filter-header-name p-overlay-badge">
                {caption}
                {showClearFiltersButton &&
                    <Badge value={numberOfActiveFilters}></Badge>
                }
            </span>
            {showClearFiltersButton &&
                <Button onClick={(event) => clearSingleFilter(event, fieldName, mapName, dispatchMap)} className="map-overlay-filter-header-clear-but" severity="secondary" icon="pi pi-filter-slash" rounded outlined />
            }
        </div>
    )
}